import CarePlanViewScreen from './CarePlanViewScreen'
import useFeatureFlags from 'hooks/useFeatureFlags'

export const CarePlanViewScreenWrapper = () => {
  const pbsFlagEnabled = useFeatureFlags({ flagNames: ['pbs'] })?.data.pbs
    .enabled

  // @ts-ignore
  return <CarePlanViewScreen pbsFlagEnabled={pbsFlagEnabled} />
}
